// extracted by mini-css-extract-plugin
export default {"page":"page___mCCf9","header":"header___OWAMO","header-title":"header-title___zE7YQ","header-actions":"header-actions___ZtLAN","space":"space___Bk5Kj","text-btn":"text-btn___Ze92z"};